"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThingShadowState = void 0;
const ModelTypes_1 = require("../types/ModelTypes");
const ModelCommon_1 = require("./ModelCommon");
const typeName = 'ThingShadowState';
const debug = process.env.REACT_APP_DEBUG && false;
class ThingShadowState extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(typeName, ob);
        this.payload = ob?.payload?.state ? ob.payload : { state: { reported: {} } };
    }
    get metrics() {
        return this.payload.state.reported;
    }
    set metrics(metrics) {
        console.log('setting metric', metrics);
        this.payload.state.reported = { ...this.payload.state.reported, ...metrics };
    }
    get calculated() {
        return this.payload.state.calculated;
    }
    getLatLon() {
        let res = undefined;
        if (this.payload.state?.reported?.position) {
            const pos = this.payload.state.reported.position;
            if ((0, ModelTypes_1.isGeofencePointsType)(pos))
                res = pos;
            else {
                console.log(`could not get posiition on Geofence ${this.name}, with `, this.payload.state.reported.position);
            }
        }
        return res;
    }
    // sk is latestThingShadowState then we want to capture states from muliple device type messages
    mergePayload(newPayload) {
        debug && console.log('Merging paylaods ', { newPayload, this: this });
        if (newPayload?.state?.reported) {
            //this would add existing field from old payload into non existing fields cf: rolls moves in v[zero]15
            // Object.assign(this.payload.state.reported, newPayload.state.reported);
            debug && console.log('We are not merging Reported');
        }
        if (newPayload?.state?.calculated) {
            if (!this.payload.state.calculated) {
                this.payload.state.calculated = newPayload.state.calculated;
            }
            else {
                Object.assign(this.payload.state.calculated, newPayload.state.calculated);
            }
        }
        // don't merge timestamps, originally this was because we wanted to update latest, but now that is not the case and will repeat lss timestamp on updates
        // if (newPayload?.timestamp) {
        //     this.payload.timestamp = newPayload.timestamp;
        // }
        this.timestamp = Math.max(this.timestamp ?? 0, newPayload.timestamp ?? 0); // This is not the payload timestamp it is the ThingShadowState
        return this;
    }
}
exports.ThingShadowState = ThingShadowState;
